export default "__VITE_ASSET__RnivfzZP__"